export default __webpack_public_path__ + "8b7f01bf7566b267e97376cbe076fa5d.png";